import CustomTextField from './TextInputStyle'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { LabelInput } from '../../Main'
import { Box, InputAdornment, useMediaQuery, useTheme } from '@mui/material'
import { Clear, Search } from '@mui/icons-material'

const SearchField = (props) => {
  const theme = useTheme()
  const matchDownMD = useMediaQuery(theme.breakpoints.down('md'))
  const {
    labelInput,
    labelStyle = { color: '#444', fontWeight: '700', fontSize: '0.875rem' },
    adornmentPosition,
    adornmentText,
    onChange,
    onSubmit,
    value = '',
    ...otherProps
  } = props
  const { t } = useTranslation()
  return (
    <>
      {labelInput && <LabelInput sx={{ ...labelStyle }}>{labelInput}</LabelInput>}
      <CustomTextField
        {...otherProps}
        sx={{
          width: '100%',
          pr: matchDownMD ? '0' : '10px',
          backgroundColor: 'white',
          borderColor: props.filled ? '#00C9A785 !important' : '#DDDDDD !important',
        }}
        value={value}
        onChange={(e) => {
          onChange(e.target.value)
        }}
        placeholder={t('placeholder.insert_keyword')}
        InputProps={{
          style: {
            paddingRight: 0,
          },
          startAdornment: matchDownMD ? (
            <></>
          ) : (
            <InputAdornment position="start">
              <Search />
            </InputAdornment>
          ),
          endAdornment: (
            <>
              {value && (
                <Box sx={{ cursor: 'pointer' }} onClick={() => onChange('')}>
                  <Clear />
                </Box>
              )}
              <InputAdornment
                position="end"
                onClick={onSubmit}
                sx={{
                  padding: '25px 25px',
                  backgroundColor: props.filled ? '#00C9A785' : theme.palette.primary.main,
                  borderTopRightRadius: '25px',
                  borderBottomRightRadius: '25px',
                  ':hover': {
                    cursor: 'pointer',
                  },
                }}
              >
                <span
                  style={{
                    fontWeight: '700',
                    color: '#fafafa',
                  }}
                >
                  {t('form.search')}
                </span>
              </InputAdornment>
            </>
          ),
        }}
      />
    </>
  )
}

SearchField.propTypes = {
  adornmentPosition: PropTypes.string,
  adornmentText: PropTypes.string,
  filled: PropTypes.any,
  inputtype: PropTypes.string,
  labelInput: PropTypes.string,
  labelStyle: PropTypes.any,
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
  props: PropTypes.any,
  value: PropTypes.any,
}

export default SearchField
